const parseTagName = (tagContent: string): { isClosing: boolean; name: string } => {
  let index = 0
  const isClosing = tagContent[index] === '/'
  if (isClosing) index += 1

  let name = ''
  while (index < tagContent.length) {
    const char = tagContent[index]
    if (char === ' ' || char === '/' || char === '\t' || char === '\n' || char === '\r') break
    name += char
    index += 1
  }

  return { isClosing, name: name.toLowerCase() }
}

/** Strip HTML tags with linear scanning (ReDoS-safe). */
const stripHtmlTagsToPlainText = (html: string): string => {
  let result = ''
  let index = 0

  while (index < html.length) {
    if (html[index] !== '<') {
      result += html[index]
      index += 1
    } else {
      const tagEnd = html.indexOf('>', index + 1)
      if (tagEnd === -1) {
        result += html.slice(index)
        break
      }

      const tagContent = html.slice(index + 1, tagEnd).trim()
      const { isClosing, name } = parseTagName(tagContent)

      if (name === 'br') {
        result += '\n'
      } else if (isClosing && name === 'p') {
        result += '\n'
      }

      index = tagEnd + 1
    }
  }

  return result
}

export const stripHtmlToPlainText = (html: string): string =>
  stripHtmlTagsToPlainText(html)
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\n{3,}/g, '\n\n')
    .trim()

export const isBlankEmailSignatureHtml = (html: string): boolean => !stripHtmlToPlainText(html)
